import { useState } from "react";

import { PlanList } from "./PlanList";
import { PlanWorkspace } from "./PlanWorkspace";

/**
 * Top-level view switch for the slice: the plan list, or a single plan's
 * workspace. Selection is local component state — the slice owns one route, so
 * there are no sub-routes to register (the route tree is frozen for the wave).
 */
export function ActionPlansApp() {
  const [planId, setPlanId] = useState<string | null>(null);

  if (planId == null) {
    return <PlanList onOpen={setPlanId} />;
  }
  return <PlanWorkspace planId={planId} onClose={() => setPlanId(null)} />;
}
